import {createSelector} from 'reselect';

export const getFindAnAdvisor = (state => {
    return state.publicWeb.findAnAdvisor
});

const makeGetField = fieldId => createSelector(
    getFindAnAdvisor,
    findAnAdvisor => findAnAdvisor[fieldId]
);

export const getSearchCriteria = makeGetField('searchCriteria');
export const getAssistanceType = makeGetField('assistanceType');
export const getIncomeBracket = makeGetField('incomeBracket');
export const getChosenLat = makeGetField('chosenLat');
export const getChosenLong = makeGetField('chosenLong');
export const getTestedLocationStatus = makeGetField('testedLocationStatus');
export const getLocationEnabled = makeGetField('locationEnabled');
export const getLocationType = makeGetField('locationType');
export const getDiscussionOptionsSelected = makeGetField('discussionOptionsSelected');
export const getFindAnAdvisorData = makeGetField('findAnAdvisorData');